<template>
  <div class="smallhome">
    <div>
      <el-date-picker
        style="margin: 10px 5%"
        v-model="firstTime_value"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
    </div>
    <div >
      <div class="echart">
        <p>看诊人数、开方数与预约人数统计图（个）</p>
        <div :style="{height:height,width:width,overflow:overflow}" ref="myEchart"></div>
      </div>
      <div class="pchart">
        <p>资金流动统计（元）<span style="margin-left: 50%">总金额：<span style="color: #db4958">{{num}}元</span></span></p>
        <div :style="{height:height,width:width,overflow:overflow}" ref="myPchart"></div>
      </div>
    </div>
    <div style="height: 400px"></div>
  </div> 
</template>
<style type="text/css" scoped>
div {
  overflow: hidden;
}
.echart {
  margin-left: 5%;
  margin-top: 30px;
  background: #fff;
  width: 48%;
  border: 1px solid #dfe6ec;
  height: 450px;
}

.pchart {
  background: #fff;
  margin-left: 5%;
  margin-top: 30px;
  width: 48%;
  border: 1px solid #dfe6ec;
}

.echart p {
  font-size: 14px;
  font-weight: bold;
  color: #1f2d3d;
  width: 100%;
  line-height: 40px;
  background-color: #eef1f6;
  padding-left: 15px;
}

.pchart p {
  font-size: 14px;
  font-weight: bold;
  color: #1f2d3d;
  width: 100%;
  line-height: 40px;
  background-color: #eef1f6;
  padding-left: 15px;
}

.block {
  margin-left: 1%;
}
</style>
<script>
import echarts from "echarts";
import store from "../../store";
import { formatDate } from "../../common/date";

export default {
  data() {
    return {
      tableData: [],
      chart: null,
      dataArrange: store.state.weeks_content,
      startDate: "",
      endDate: "",
      firstTime_value: [Date.now() - 8.64e7 * 6, Date.now()],
      num:''
    };
  },
  mounted: function() {
    this.getinfo();
  },

  watch: {
    firstTime_value: function() {
      this.startDate = formatDate(this.firstTime_value[0], "yyyy-MM-dd");
      this.endDate = formatDate(this.firstTime_value[1], "yyyy-MM-dd");
      this.getinfo();
    }
  },

  // 图表部分
  // props接收父组件的数据
  props: {
    // 设置图表的宽度
    width: {
      type: String,
      default: "98%"
    },
    // 设置图表的高度
    height: {
      type: String,
      default: "400px"
    },
    overflow: {
      //type:String,
      default: "hidden"
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    getinfo: function() {
      (this.startDate = formatDate(this.firstTime_value[0], "yyyy-MM-dd")),
        (this.endDate = formatDate(this.firstTime_value[1], "yyyy-MM-dd"));
      this.$axios({
        url: "/api/homepage/" + this.startDate + "/" + this.endDate,
        method: "GET"
      })
        .then(res => {
          let y2 = res.data.data.y2;
          let num = 0;
          for (let p=0;p<y2.length;p++){
            num+=y2[p];
          }
          this.num = num;
          this.tableData = res.data.data;
          this.initChart();
          console.log(typeof this.tableData);
        })
        .catch(err => {
          console.log(err.data);
        });
    },
    initChart() {
      //let Y = this.tableData.y;

      let Y = JSON.parse(JSON.stringify(this.tableData.y));
      let Y1 = JSON.parse(JSON.stringify(this.tableData.y1));
      let Y_max = Y.sort(function(a, b) {
        return b - a;
      })[0];
      let Y1_max = Y1.sort(function(a, b) {
        return b - a;
      })[0];

      console.log(Y_max);
      // 对图表进行初始化
      this.chart = echarts.init(this.$refs.myEchart);
      this.chart_p = echarts.init(this.$refs.myPchart);
      // 把配置和数据放这里
      this.chart.setOption({
        // color: ['#3398DB'],
        //提示框
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            // 鼠标悬浮在柱上的效果
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'，
          }
        },
        // 图表的位置
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true
        },
        //工具箱，仅有一个
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            saveAsImage: { show: true },
            magicType: { show: true, type: ["line", "bar"] },
            restore: { show: true }
          }
        },
        //图例
        legend: {
          //selectedMode: false,
          data: ["看诊人数", "开方数", "预约人数"]
        },
        // 数据区域缩放
        dataZoom: {
          show: true,
          realtime: true,
          x: 55,
          y: 370,
          //width: 400,
          height: 20,
          backgroundColor: "rgba(221,160,221,0.5)",
          //dataBackgroundColor: 'rgba(138,43,226,0.5)',
          //fillerColor: 'rgba(38,143,26,0.6)',
          // handleColor: 'rgba(128,43,16,0.8)',
          start: 0,
          end: 100
        },
        xAxis: [
          {
            type: "category",
            data: this.tableData.x,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        // yAxis: [
        //   {
        //     type: "value",
        //     scale: true,
        //     max: Y_max + 30,
        //     min: 0,
        //     name: "看病人数"
        //   },
        //   {
        //     type: "value",
        //     scale: true,
        //     max: Y1_max,
        //     min: 0,
        //     name: "开方数"
        //   }
        // ],
        series: [
          {
            name: "看诊人数",
            type: "bar",
            barWidth: "20%",
            data: this.tableData.y,
            label: {
              normal: {
                show: true,
                position: "top"
              }
            }
          },
          {
            name: "开方数",
            type: "bar",
            barWidth: "20%",
            data: this.tableData.y1,
            label: {
              normal: {
                show: true,
                position: "top"
              }
            }
          },
          {
            name: "预约人数",
            type: "bar",
            barWidth: "20%",
            data: this.tableData.y3,
            label: {
              normal: {
                show: true,
                position: "top"
              }
            }
          }
        ]
        // magicType: {
        //   show : true,
        //   title : {
        //     line : '动态类型切换-折线图',
        //     bar : '动态类型切换-柱形图',
        //     stack : '动态类型切换-堆积',
        //     tiled : '动态类型切换-平铺'
        //   },
        //   type : ['line', 'bar', 'stack', 'tiled']
        // },
      }),
        //   资金流动统计图
        this.chart_p.setOption({
          color: ["#db4958"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              // 鼠标悬浮在柱上的效果
              type: "line" // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          // 图表的位置
          grid: {
            left: "3%",
            right: "4%",
            bottom: "8%",
            containLabel: true
          },
          legend: {
            //selectedMode: false,
            data: ["资金流动"]
          },
          toolbox: {
            show: true,
            feature: {
              mark: { show: true },
              saveAsImage: { show: true },
              magicType: { show: true, type: ["line", "bar"] },
              restore: { show: true }
            }
          },
          dataZoom: {
            show: true,
            realtime: true,
            x: 55,
            y: 370,
            //width: 400,
            height: 20,
            backgroundColor: "rgba(221,160,221,0.5)",
            //dataBackgroundColor: 'rgba(138,43,226,0.5)',
            //fillerColor: 'rgba(38,143,26,0.6)',
            // handleColor: 'rgba(128,43,16,0.8)',
            start: 0,
            end: 100
          },
          xAxis: [
            {
              type: "category",
              data: this.tableData.x,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: "value",
              name: "金额"
            }
          ],
          series: [
            {
              name: "金额",
              type: "bar",
              barWidth: "40%",
              data: this.tableData.y2,
              label: {
                normal: {
                  show: true,
                  position: "top"
                }
              }
            }
          ]
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// hello.vue?5b33c385